
/**
 * 플랫폼 지원
 */
export type CourseSectionLecturesItemPlatformSupport = typeof CourseSectionLecturesItemPlatformSupport[keyof typeof CourseSectionLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseSectionLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
